import { combineReducers, UnknownAction } from '@reduxjs/toolkit'
import { appReducer } from './appSlice'
import { authReducer } from '../../pages/Login/redux'
import { favoritesReducer } from './favoritesSlice'
import { tagsReducer } from './tagsSlice'
import { buildingTagsReducer } from './buildingTagsSlice'
import { enhancedFavoritesReducer } from './enhancedFavoritesSlice'
import { wmsLayersReducer } from './wmsLayersSlice'

const rootReducer = combineReducers({
  ...appReducer,
  ...authReducer,
  ...favoritesReducer,
  ...tagsReducer,
  ...buildingTagsReducer,
  ...enhancedFavoritesReducer,
  ...wmsLayersReducer,
})

export type RootState = ReturnType<typeof rootReducer>

export default (state: RootState | undefined, action: UnknownAction) => {
  if (action.type === 'auth/logout') {
    state = undefined
  }

  return rootReducer(state, action)
}
